<template>
  <div class="tool-bar-wrapper" v-if="type !== 'bookShelf'" :class="{ mobile: isMobile }">
    <div class="button-group" :class="{ bottom1: isShowFooter }">
      <img
        class="collect-button"
        :class="{ position1: charge !== 1 && showShop !== 1 && questionnaire !== 1 }"
        v-if="showCollect"
        :src="isCollect ? require('@imgs/toolbar/collect-button1.png') : require('@imgs/toolbar/collect-button.png')"
        @click="collect()"
        alt="收藏"
      />
      <book-footer :use-button="'switchDate'" ref="switchDateButton"></book-footer>
      <img
        class="show-button"
        v-if="charge === 1 || showShop === 1 || questionnaire === 1"
        :src="showButtons ? require('@imgs/toolbar/run-button-close.png') : require('@imgs/toolbar/run-button-open.png')"
        @click="showButtons = !showButtons"
        alt="展开"
      />
    </div>

    <div class="tool-bar" v-show="showButtons" :style="{ zIndex: showTotalPage }" :class="{ 'mobile-tool-bar': isMobile }">
      <img
        v-if="charge === 1 && !isPaper && chargeIconType < 20"
        v-show="!isOrdered"
        class="toolbarImg tool-bar-questionaire"
        :class="{ 'mobile-toolbarImg': isMobile }"
        @click="showOrder"
        :src="chargeButtonImg"
      />
      <img v-if="charge === 1 && isPaper && needPay" class="toolbarImg tool-bar-questionaire" :class="{ 'mobile-toolbarImg': isMobile }" @click="showOrder('paper')" src="@imgs/toolbar/order2.png" />
      <div
        class="text-button"
        v-else-if="charge === 1 && !isPaper && chargeIconType >= 20"
        v-show="!isOrdered"
        :class="[isMobile && 'mobile-toolbarImg', 'text-' + chargeIconType]"
        v-html="chargeIcon"
        @click="showOrder"
      ></div>
      <!-- pc开始 -->
      <div v-if="showShop == 1 && !isMobile" class="shop-btn-wrapper" style="position: relative;">
        <div class="show-shop-content" v-show="ifLink" :style="{ top: itemTop() }" @mouseout="mouseoutItem($event)" @mouseover="mouseoverItem($event)">
          <div class="show-shop " style="">
            <div v-show="ifLink" v-for="(item, index) in linkList" :key="index" class="link-item link-item-pc" @click="goShop(item)" @mouseout="mouseout($event)" @mouseover="mouseover($event)">
              {{ item.name }}
            </div>
          </div>
          <img v-show="ifLink" src="../../assets/imgs/xjt.png" style="width: 25px; height: 30px; position: absolute; right: 25px; bottom: 15px;" />
          <div v-show="ifLink" id="" style="width: 100%;height: 30px;"></div>
        </div>

        <img
          v-if="linkList.length > 1 && buyIconType < 20"
          class="toolbarImg tool-bar-questionaire"
          :class="{ 'mobile-toolbarImg': isMobile }"
          @mouseout="mouseoutImg($event)"
          @mouseover="mouseoverImg($event)"
          :src="buyLinkButtonImg"
        />
        <img v-if="linkList.length <= 1 && buyIconType < 20" class="toolbarImg tool-bar-questionaire" :class="{ 'mobile-toolbarImg': isMobile }" @click="goShopone" :src="buyLinkButtonImg" />
        <div
          class="text-button"
          v-if="linkList.length > 1 && buyIconType >= 20"
          :class="[isMobile && 'mobile-toolbarImg', 'text-' + buyIconType]"
          @mouseout="mouseoutImg($event)"
          @mouseover="mouseoverImg($event)"
          v-html="buyIcon"
        ></div>
        <div class="text-button" v-if="linkList.length <= 1 && buyIconType >= 20" :class="[isMobile && 'mobile-toolbarImg', 'text-' + buyIconType]" @click="goShopone" v-html="buyIcon"></div>
      </div>
      <!-- pc结束 -->
      <!-- 手机开始 -->
      <div v-if="showShop == 1 && isMobile" style="position: relative;">
        <div class="show-shop-content" v-show="ifLink" :style="{ top: itemTop(), right: '-15px' }" @mouseout="mouseoutItem($event)" @mouseover="mouseoverItem($event)">
          <div class="show-shop show-shop-phone" style="">
            <div v-show="ifLink" v-for="(item, index) in linkList" :key="index" class="link-item link-item-phone" @click="goShop(item)">
              {{ item.name }}
            </div>
          </div>
          <img v-show="ifLink" src="../../assets/imgs/xjt.png" style="width: 25px; height: 30px; position: absolute; right: 25px; bottom: 15px;" />
          <div v-show="ifLink" id="" style="width: 100%;height: 30px;"></div>
        </div>

        <img v-if="linkList.length > 1 && buyIconType < 20" class="toolbarImg tool-bar-questionaire" :class="{ 'mobile-toolbarImg': isMobile }" @click="mouseoverImgPhone" :src="buyLinkButtonImg" />
        <img v-if="linkList.length <= 1 && buyIconType < 20" class="toolbarImg tool-bar-questionaire" :class="{ 'mobile-toolbarImg': isMobile }" @click="goShopone" :src="buyLinkButtonImg" />
        <div class="text-button" v-if="linkList.length > 1 && buyIconType >= 20" :class="[isMobile && 'mobile-toolbarImg', 'text-' + buyIconType]" v-html="buyIcon" @click="mouseoverImgPhone"></div>
        <div class="text-button" v-if="linkList.length <= 1 && buyIconType >= 20" :class="[isMobile && 'mobile-toolbarImg', 'text-' + buyIconType]" v-html="buyIcon" @click="goShopone"></div>
      </div>
      <!-- 手机结束 -->
      <img
        v-if="questionnaire === 1 && questionIconType < 20"
        class="toolbarImg tool-bar-questionaire"
        :class="{ 'mobile-toolbarImg': isMobile }"
        @click="goQuestionaire"
        :src="questionnaireButtonImg"
      />
      <div
        class="text-button"
        v-if="questionnaire === 1 && questionIconType >= 20"
        :class="[isMobile && 'mobile-toolbarImg', 'text-' + questionIconType]"
        v-html="questionIcon"
        @click="goQuestionaire"
      ></div>
      <questionaireForm ref="questionaireForm"></questionaireForm>
      <order-dialog ref="orderDialog" v-if="charge === 1 && needPay && !isPaper" @collect="collect"></order-dialog>
      <baozhi-order-dialog ref="orderDialogBaozhi" v-if="charge === 1 && needPay && isPaper" @collect="collect"></baozhi-order-dialog>
    </div>
  </div>
  <div v-else class="album_tool-bar-wrapper" :class="{ mobile: isMobile }">
    <!--TODO 修改按钮图片-->
    <div v-if="charge === 1" class="button-order" :class="{ wider: isOrdered, simple: showStyle === 1, wood: showStyle === 0 }" @click="showOrder()">
      <img v-if="showStyle === 1 && !isMobile" class="collect-button" :src="!isOrdered ? require('@imgs/bookshelf/order-white.png') : require('@imgs/bookshelf/order-white1.png')" />
      <img v-else class="collect-button" :src="!isOrdered ? require('@imgs/bookshelf/order-wood.png') : require('@imgs/bookshelf/order-wood1.png')" />
      <span>{{ isOrdered ? languageOption.subscribed : languageOption.subscription }}</span>
    </div>
    <order-dialog :type="type" ref="orderDialog" v-if="charge === 1 && needPay" @collect="collect"></order-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import questionaireForm from '@components/questionnaire'
import OrderDialog from './components/OrderDialog'
import { isLogin } from '@/utils'
import homeApi from '@api/home'
import BookFooter from '../books/bookFooter'
import BaozhiOrderDialog from '@components/toolbar/components/BaozhiOrderDialog.vue'

export default {
  data() {
    return {
      direction: 'ttb',
      isBigScreen: false, //是否是iphone屏幕
      linkList: [],
      showButtons: true,
      ifLink: false,
      isCollect: false,
      collectId: ''
    }
  },
  props: {
    type: {
      default: 'book',
      type: String
    },
    showStyle: {
      default: 0,
      type: Number
    },
    worksId: {
      default: 0
    }
  },
  computed: {
    ...mapState('book', ['isShowWindow', 'isMobile']),
    ...mapState('config', {
      questionnaire: (state) => state.bookObj.questionnaire,
      questionType: (state) => state.bookObj.questionType,
      questionContentLink: (state) => state.bookObj.questionContentLink,
      buyIconType: (state) => state.bookObj.buyIconType || 1,
      chargeIconType: (state) => state.bookObj.chargeIconType || 0,
      questionIconType: (state) => state.bookObj.questionIconType || 0,
      historyResource: (state) => state.bookObj.historyResource
    }),
    isPaper() {
      return this.$store.state.book.isPaper
    },
    isShowFooter() {
      return this.$store.state.book.isShowFooter
    },
    charge() {
      return this.$store.state.config[this.type + 'Obj'].charge
    },
    buyIcon() {
      return typeof this.$store.state.config.bookObj.buyIcon === 'string' ? this.$store.state.config.bookObj.buyIcon.replaceAll(' ', '&nbsp;') : this.$store.state.config.bookObj.buyIcon
    },
    questionIcon() {
      return typeof this.$store.state.config.bookObj.questionIcon === 'string' ? this.$store.state.config.bookObj.questionIcon.replaceAll(' ', '&nbsp;') : this.$store.state.config.bookObj.questionIcon
    },
    chargeIcon() {
      return typeof this.$store.state.config.bookObj.chargeIcon === 'string' ? this.$store.state.config.bookObj.chargeIcon.replaceAll(' ', '&nbsp;') : this.$store.state.config.bookObj.chargeIcon
    },
    worksObj() {
      return this.$store.state.config[this.type + 'Obj']
    },
    showCollect() {
      return this.type === 'book' ? this.worksObj.displayOrNot.collect === 1 : true
    },
    currentPage() {
      return this.$store.state.book.currentPage
    },
    goodsObj() {
      return this.$store.state.common.goodsObj
    },
    isOrdered() {
      return this.$store.state.common.isOrdered
    },
    needPay() {
      let currentUser = localStorage.getItem('username')
      return this.charge !== 0 && this.goodsObj.creator != currentUser && !this.$store.state.common.isOrdered && ((this.goodsObj.price && this.goodsObj.price > 0) || this.goodsObj.secret === 1)
    },
    isEditDrawerShow() {
      return this.$store.state.edit.isEditDrawerShow
    },
    // 控制左侧显示树还是编辑区域
    currentEditHeader() {
      return this.$store.state.edit.currentEditHeader
    },
    showLink() {
      return this.$store.state.config.bookObj.buyLink
    },
    showShop() {
      return this.$store.state.config.bookObj.shop
    },
    showTotalPage() {
      return this.$store.state.book.showTotalPage + 1
    },
    questionnaireButtonImg() {
      return this.questionIcon?.length > 1 ? this.questionIcon : require(`../../assets/imgs/questionnaire/button_questionnaire${this.questionIcon || 0}@2x.png`)
    },
    chargeButtonImg() {
      return this.chargeIcon?.length > 1 ? this.chargeIcon : require(`../../assets/imgs/toolbar/order${this.chargeIcon || 0}.png`)
    },
    buyLinkButtonImg() {
      return this.buyIcon?.length > 1 ? this.buyIcon : require(`../../assets/imgs/buyLink/button${this.buyIcon || 1}.png`)
    },
    workType() {
      switch (this.$route.name) {
        case 'paperDefault':
        case 'paperContentDefault':
          return 'cloud_read_epaper'
        case 'bookshelfDetail':
          return 'cloud_read_album'
        case 'bookLibdetail':
          return 'cloud_read_lib'
        default:
          return 'cloud_read_ebook'
      }
    },
    historyResource() {
      return this.$store.state.config.bookObj.historyResource
    },
    entryName() {
      return this.$store.state.config.bookObj.entryName
    },
    entryUrl() {
      return this.$store.state.config.bookObj.entryUrl
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.currentLang]
    },
    currentLang() {
      return this.$store.state.config[this.type + 'Obj'].language
    }
  },
  watch: {
    showLink: {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          let Link = JSON.parse(newVal)
          let list = []
          if (Link.a.name !== undefined) {
            list.push(Link.a)
          }
          if (Link.b.name !== undefined) {
            list.push(Link.b)
          }
          if (Link.c.name !== undefined) {
            list.push(Link.c)
          }
          if (Link.d.name !== undefined) {
            list.push(Link.d)
          }
          if (Link.e.name !== undefined) {
            list.push(Link.e)
          }
          this.linkList = list
        } else {
          this.linkList = []
        }
      },
      deep: true,
      immediate: true
    },
    worksId() {
      let param = {
        worksId: this.worksId || this.$route.query.id,
        worksType: this.workType
      }
      homeApi.findOneSubscribe(param).then((res) => {
        this.$store.commit('common/UPDATE_IS_ORDERED', res.data.status === 0)
        if (res.data.status === 0) {
          this.$refs.orderDialog.dialogVisible = false
        }
      })
      homeApi.findOneCollect(param).then((res) => {
        if (res.data.status === 0) {
          this.collectId = res.data.data.id
          this.isCollect = true
        }
      })
    },
    currentPage(val, oldVal) {
      //页码试读翻页弹付费弹窗时，先检测文章是否需要收费
      setTimeout(() => {
        if (this.type === 'book' && !this.$store.state.book.orderDialogVisible) {
          if ((val[0] > this.goodsObj.chargePage || val[1] > this.goodsObj.chargePage) && this.needPay) {
            isLogin()
            if (this.goodsObj.secret === 1 || this.charge === 2) {
              this.$alert('抱歉您没有权限继续阅读此作品。', { title: '提示', customClass: this.isMobile ? 'secret-message-box_mobile' : '', showClose: false, showConfirmButton: false })
            } else {
              if (this.isPaper) {
                this.$refs.orderDialogBaozhi.dialogVisible = true
              } else {
                this.$refs.orderDialog.dialogVisible = true
              }
              this.$store.commit('book/UPDATE_CURRENT_PAGE', oldVal[0] < this.goodsObj.chargePage ? oldVal : [this.goodsObj.chargePage - 1 || 1, this.goodsObj.chargePage])
            }
          }
        }
      }, 1000)
    }
  },
  methods: {
    itemTop() {
      if (this.linkList.length == 2) {
        return this.buyIconType < 20 || this.isMobile ? '-120px' : '-100px'
      } else if (this.linkList.length == 3) {
        return this.buyIconType < 20 || this.isMobile ? '-166px' : '-146px'
      } else if (this.linkList.length == 4) {
        return this.buyIconType < 20 || this.isMobile ? '-212px' : '-192px'
      } else if (this.linkList.length == 5) {
        return this.buyIconType < 20 || this.isMobile ? '-258px' : '-238px'
      }
    },
    mouseoutItem($event) {
      this.ifLink = false
    },
    mouseoverItem($event) {
      this.ifLink = true
    },
    mouseoutImg($event) {
      this.ifLink = false
    },
    mouseoverImgPhone() {
      this.ifLink = !this.ifLink
    },
    mouseoverImg() {
      this.ifLink = true
    },
    mouseout($event) {
      $event.currentTarget.className = 'link-item'
    },
    mouseover($event) {
      $event.currentTarget.className = 'active-link-item'
    },
    goShopone() {
      if (this.linkList.length == 1 && this.linkList[0].link) {
        window.open(this.linkList[0].link, '_blank')
      }
    },
    goShop(item) {
      if (item.link !== '') {
        this.ifLink = false
        window.open(item.link, '_blank')
      }
    },
    goQuestionaire() {
      if (this.questionType === 0) {
        this.$refs.questionaireForm.visible = true
      } else if (this.questionType === 1) {
        if (this.questionContentLink !== '') {
          window.open(this.questionContentLink, '_blank')
        }
      }
    },
    async collect(type) {
      await isLogin()
      let param = {
        worksId: this.worksId || this.$route.query.id,
        worksName: this.worksObj.title,
        creator: this.worksObj.creator,
        readModel: this.worksObj.readModel,
        worksType: this.workType
      }
      if (this.isCollect && type !== 'order') {
        homeApi.cancelCollect({ ids: this.collectId }).then((res) => {
          if (res.data.status === 0) {
            this.$message({
              message: this.languageOption.unsubscribed,
              type: 'success'
            })
            this.isCollect = false
            this.collectId = ''
          }
        })
      } else {
        homeApi.collectWork(param).then((res) => {
          if (res.data.status === 0) {
            this.$message({
              message: this.languageOption.addedToFavorites,
              type: 'success'
            })
            this.isCollect = true
            this.collectId = res.data.data.id
          } else {
            this.$message({
              message: res.data.message || '收藏失败',
              type: 'error'
            })
          }
        })
      }
    },
    async showOrder(type) {
      await isLogin()
      if (this.needPay) {
        this.$nextTick(() => {
          if (this.goodsObj.secret === 1 || this.charge === 2) {
            this.$alert('抱歉您没有权限继续阅读此作品。', { title: '提示', customClass: this.isMobile ? 'secret-message-box_mobile' : '', showClose: false, showConfirmButton: false })
          } else {
            if (type === 'paper') {
              this.$refs.orderDialogBaozhi.dialogVisible = true
            } else {
              this.$refs.orderDialog.dialogVisible = true
            }
          }
        })
      } else {
        let currentUser = localStorage.getItem('username')
        if (this.goodsObj.creator == currentUser) {
          this.$message(this.currentLang === 1 ? 'You are the author, no need to subscribe.' : '您是作者，无需订阅。')
        } else if (this.isOrdered) {
          this.$message(this.languageOption.subscribedTip)
        } else {
          this.$message('该作品可免费试读')
        }
      }
    },
    toHistory() {
      if (!this.entryUrl) return
      window.open(this.entryUrl, '_blank')
    }
  },
  created() {
    let param = {
      worksId: this.worksId || this.$route.query.id,
      worksType: this.workType
    }
    if (!this.isPaper) {
      homeApi.findOneSubscribe(param).then((res) => {
        this.$store.commit('common/UPDATE_IS_ORDERED', res.data.status === 0)
        if (res.data.status === 0) {
          this.$refs.orderDialog.dialogVisible = false
        }
      })
    }
    homeApi.findOneCollect(param).then((res) => {
      if (res.data.status === 0) {
        this.collectId = res.data.data.id
        this.isCollect = true
      }
    })
  },
  components: {
    BaozhiOrderDialog,
    BookFooter,
    OrderDialog,
    questionaireForm
  }
}
</script>

<style scoped lang="scss">
.tool-bar-wrapper {
  z-index: 2;
  .button-group {
    position: absolute;
    right: 0;
    bottom: 10px;
    height: fit-content;
    .show-button {
      width: 32px;
      display: block;
      margin-top: 5px;
      height: 32px;
    }
    .collect-button {
      width: 32px;
      height: 32px;
      display: block;
      margin-bottom: 5px;
    }
  }
  &.mobile {
    .button-group {
      display: flex;
      bottom: 0;
      z-index: 999;
      &.bottom1 {
        bottom: 0;
      }
      .show-button {
        margin-top: 0;
        margin-left: 5px;
      }
      .collect-button {
        margin-right: 5px;
        margin-bottom: 0;
      }
    }
  }
}
.show-shop-content {
  position: relative;
  position: absolute;
  top: -120px;
  right: 0;
  width: 230px;
  .show-shop-phone {
    box-shadow: 1px 1px 10px #ececec;
  }
  .show-shop {
    overflow: hidden;
    margin: 5px !important;
    box-sizing: border-box;
    width: 220px;
    height: 100%;
    border-radius: 10px;
    .link-item {
      background-color: #fff;
      width: 100%;
      height: 46px;
      line-height: 46px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
    }
    .link-item-pc {
      border-bottom: 1px solid #f5f5f5;
    }
    .link-item-phone {
      border-bottom: 1px solid #efefef;
    }
  }
}

.tool-bar {
  height: 80px;
  display: inline-flex;
  margin-right: 40px;
  &.mobile-tool-bar {
    height: fit-content;
    margin-bottom: 50px;
    margin-right: 0;
    flex-direction: column;
  }
  .toolbarImg {
    width: 80px;
    height: 80px;
    cursor: pointer;
    margin-left: 20px;
    &.mobile-toolbarImg {
      width: 70px;
      height: 70px;
      margin-bottom: 10px;
      margin-left: 0;
    }
  }
  .link-item {
    width: 100%;
    height: 46px;
    line-height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }
  .link-item-active {
    width: 0;
    height: 0;
  }
  .shop-btn-wrapper {
    text-align: center;
    display: flex;
    align-items: center;
  }
  .text-button {
    margin: auto 10px;
    vertical-align: middle;
    &.text-20 {
      padding: 0 15px 3px;
      font-weight: bold;
      font-size: 22px;
      background-color: #fff100;
      border-radius: 20px;
    }
    &.text-21 {
      padding: 0 10px 3px;
      font-weight: bold;
      font-size: 22px;
      background-color: #2ea7e0;
      color: #fff;
      border-radius: 3px;
    }
  }

  .active-link-item {
    width: 100%;
    height: 46px;
    line-height: 46px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
    background-color: #ffede8;
  }
  &.mobile-tool-bar {
    align-items: center;
    .text-button {
      margin: 5px 0;
      width: fit-content;
    }
  }
}
.album_tool-bar-wrapper {
  .button-order {
    min-width: 78px;
    width: fit-content;
    height: 30px;
    display: inline-flex;
    align-items: center;
    border-radius: 14px;
    cursor: pointer;
    padding-right: 8px;
    &.wood {
      color: #fff;
      background-color: #5b2817;
    }
    &.simple {
      border: 1px solid #3f3f3f;
    }
    &.wider {
      min-width: 90px;
    }
    img {
      width: 20px;
      height: 20px;
      margin-left: 8px;
      margin-right: 9px;
    }
    span {
      font-size: 14px;
      line-height: 26px;
      white-space: nowrap;
      display: block;
    }
  }
  &.mobile {
    .button-order {
      min-width: 71px;
      height: 30px;
      border: none;
      background: none;
      &.wider {
        img {
          /*margin-right: 3px;
          margin-left: 7px;*/
        }
      }
      img {
        width: 14px;
        height: auto;
        margin-right: 10px;
        margin-left: 0;
      }
      span {
        font-size: 14px;
      }
    }
  }
}
</style>
